export default {
    intro: 'Hãy nhìn các gợi ý như phụ âm đầu, nghĩa, ví dụ<br />và suy luận xem đó là từ gì!',
    word: 'Từ', meaning: 'Nghĩa', example: 'Ví dụ', resources: 'Tài liệu',
    teacherFooter: { left: 'Vui lòng chọn từ trong câu hỏi bên trái.' },
    table: { question: 'Câu hỏi', emptyMessage: 'Không có nội dung.' },
};
